<template>

    <crud-container :name="name">

        <crud-nav>
            <crud-nav-header title="Company Users"></crud-nav-header>

            <crud-nav-scroll>

                <h3 v-if="active_users.length">Active</h3>
                <ul>
                    <li v-for="user in active_users">
                        <div class="name">
                            <a href="#" @click.prevent="viewItem(user)">
                                {{ user.name }}
                            </a>
                        </div>
                    </li>
                </ul>

                <h3 v-if="invited_users.length">Invited</h3>
                <ul>
                    <li v-for="user in invited_users">
                        <div class="name">
                            <a href="#" @click.prevent="viewItem(user)">
                                {{ user.name }}
                            </a>
                        </div>
                    </li>
                </ul>

                <h3 v-if="uninvited_users.length">Not Invited</h3>
                <ul>
                    <li v-for="user in uninvited_users">
                        <div class="name">
                            <a href="#" @click.prevent="viewItem(user)">
                                {{ user.name }}
                            </a>
                        </div>
                    </li>
                </ul>

                <h3 v-if="inactive_users.length">Inactive</h3>
                <ul>
                    <li v-for="user in inactive_users">
                        <div class="name">
                            <a href="#" @click.prevent="viewItem(user)">
                                {{ user.name }}
                            </a>
                        </div>
                    </li>
                </ul>

            </crud-nav-scroll>
        </crud-nav>

        <crud-main>
            <crud-new>
                <crud-main-header title="Create New User" can-go-back-to-nav="true"></crud-main-header>

                <crud-errors :errors="errors"></crud-errors>

                <div class="record-link-button-container">
                    <a href="#" class="record-link-button" @click.prevent="new_from_contact = true" :class="{ active: new_from_contact }"><i class="fa fa-user"></i> Create From Contact</a>
                    <a href="#" class="record-link-button" @click.prevent="new_from_contact = false" :class="{ active: !new_from_contact }"><i class="fa fa-plus"></i> Create From New</a>
                </div>

                <dl v-if="new_from_contact">
                    <dt>Contact</dt>
                    <dd>
                        <v-select v-model="new_item.person" placeholder="Choose a contact..." :options="people"></v-select>
                    </dd>
                </dl>
                <dl v-else>
                    <dt>Title</dt>
                    <dd><input type="text" v-model="new_item.title"/></dd>
                    <dt>First Name</dt>
                    <dd><input type="text" v-model="new_item.first_name"/></dd>
                    <dt>Last Name</dt>
                    <dd><input type="text" v-model="new_item.last_name"/></dd>
                    <dt>Email</dt>
                    <dd><input type="text" v-model="new_item.email"/></dd>
                    <dt>Phone</dt>
                    <dd><input type="text" v-model="new_item.phone"/></dd>
                    <dt>Secondary Phone</dt>
                    <dd><input type="text" v-model="new_item.phone_secondary"/></dd>
                    <dt>Address</dt>
                    <dd><input type="text" v-model="new_item.address"/></dd>
                    <dt>Postcode</dt>
                    <dd><input type="text" v-model="new_item.postcode"/></dd>
                </dl>

                <hr />
                <dl>
                    <dt>Is Employee</dt>
                    <dd><input type="checkbox" value="1" v-model="new_item.is_employee"/></dd>
                    <dt>Is Active</dt>
                    <dd><input type="checkbox" value="1" v-model="new_item.is_active"/></dd>
                    <dt>Remote Access</dt>
                    <dd><input type="checkbox" value="1" v-model="new_item.is_remote"/></dd>
                    <dt>Internal Context</dt>
                    <dd><input type="checkbox" value="1" v-model="new_item.internal_context"/></dd>
                    <dt>Client Context</dt>
                    <dd><input type="checkbox" value="1" v-model="new_item.client_context"/></dd>
                    <dt>Supplier Context</dt>
                    <dd><input type="checkbox" value="1" v-model="new_item.supplier_context"/></dd>
                </dl>

                <div class="action-button-group">
                    <a href="#" disabled class="action-button action-button-dismiss hidden-desktop"
                       @click.prevent="backToNav()">
                        <i class="fa fa-chevron-left" aria-hidden="true"></i> Back
                    </a>
                    <a href="#" disabled class="action-button action-button-success" @click.prevent="addItem()">
                        <i class="fa fa-plus-square-o" aria-hidden="true"></i> Create User
                    </a>
                </div>

            </crud-new>
            <crud-edit>
                <crud-main-header :title="'Editing: '+current_item.name" can-edit="true" can-go-back="true"
                                  :item="current_item"></crud-main-header>

                <crud-errors :errors="errors"></crud-errors>

                <dl>
                    <dt>Title</dt>
                    <dd><input type="text" v-model="current_item.title"/></dd>
                    <dt>First Name</dt>
                    <dd><input type="text" v-model="current_item.first_name"/></dd>
                    <dt>Last Name</dt>
                    <dd><input type="text" v-model="current_item.last_name"/></dd>
                    <dt>Email</dt>
                    <dd><input type="text" v-model="current_item.email"/></dd>
                    <dt>Phone</dt>
                    <dd><input type="text" v-model="current_item.phone"/></dd>
                    <dt>Secondary Phone</dt>
                    <dd><input type="text" v-model="current_item.phone_secondary"/></dd>
                </dl>

                <hr />
                <dl>
                    <dt>Is Active</dt>
                    <dd><input type="checkbox" value="1" v-model="current_item.is_active"/></dd>
                    <dt>Remote Access</dt>
                    <dd><input type="checkbox" value="1" v-model="current_item.is_remote"/></dd>
                    <dt>Internal Context</dt>
                    <dd><input type="checkbox" value="1" v-model="current_item.internal_context"/></dd>
                    <dt>Client Context</dt>
                    <dd><input type="checkbox" value="1" v-model="current_item.client_context"/></dd>
                    <dt>Supplier Context</dt>
                    <dd><input type="checkbox" value="1" v-model="current_item.supplier_context"/></dd>
                </dl>

                <div class="action-button-group">
                    <a href="#" class="action-button action-button-dismiss" @click.prevent="backToItem()">
                        <i class="fa fa-chevron-left" aria-hidden="true"></i> Back
                    </a>
                    <a href="#" class="action-button action-button-success" @click.prevent="saveItem()">
                        <i class="fa fa-check" aria-hidden="true"></i> Update User
                    </a>
                </div>

            </crud-edit>
            <crud-view>
                <crud-main-header :title="current_item.name" can-go-back-to-nav="true" can-edit="true" :item="current_item"></crud-main-header>

                <tab-list v-if="viewing_item">
                    <tab name="Overview" active="true">
                        <dl>
                            <dt>Title</dt>
                            <dd>{{ current_item.title }}</dd>
                            <dt>First Name</dt>
                            <dd>{{ current_item.first_name }}</dd>
                            <dt>Last Name</dt>
                            <dd>{{ current_item.last_name }}</dd>
                            <dt>Email</dt>
                            <dd>{{ current_item.email }}</dd>
                            <dt>Phone</dt>
                            <dd>{{ current_item.phone }}</dd>
                            <dt>Secondary Phone</dt>
                            <dd>{{ current_item.phone_secondary }}</dd>
                        </dl>
                        <hr/>
                        <dl>
                            <dt>Invited</dt>
                            <dd>{{ current_item.is_invited | human_bool }}</dd>
                            <dt>Account Setup</dt>
                            <dd>{{ current_item.is_setup | human_bool }}</dd>
                            <dt>Account Active</dt>
                            <dd>{{ current_item.is_active | human_bool }}</dd>
                            <dt>Remote Access</dt>
                            <dd>{{ current_item.is_remote | human_bool }}</dd>
                            <dt>Last Authentication</dt>
                            <dd>{{ current_item.last_authentication }}</dd>
                        </dl>
                        <hr/>
                        <a href="#" @click.prevent="sendInvite(current_item)" class="record-link-button" v-if="current_item.can_send_invite"><i class="fa fa-envelope"></i> Send Invite</a>
                        <a :href="current_item._links.frontend.contact" class="record-link-button"><i class="fa fa-user"></i> View Contact</a>
                        <a v-if="current_item.is_employee" :href="current_item._links.frontend.employee" class="record-link-button"><i class="fa fa-user"></i> View Employee</a>
                    </tab>
                    <tab name="Contexts">
                        <dl>
                            <dt>Internal Context</dt>
                            <dd>{{ current_item.internal_context | human_bool }}</dd>
                            <dt>Client Context</dt>
                            <dd>{{ current_item.client_context | human_bool }}</dd>
                            <dt>Supplier Context</dt>
                            <dd>{{ current_item.supplier_context | human_bool }}</dd>
                        </dl>
                    </tab>
                </tab-list>

            </crud-view>
        </crud-main>

    </crud-container>
</template>

<script>
    import vSelect from "vue-select";
    import flatPickr from 'vue-flatpickr-component';

    export default {
        components: {
            vSelect, flatPickr
        },
        data() {
            return {
                name: 'users',
                items: [],
                current_item: {},
                people: [],
                new_item: {},
                search_query: null,
                errors: null,
                new_from_contact: true
            }
        },
        watch: {},
        filters: {

        },
        computed: {
            has_query() {
                return this.search_query != '' && !_.isNull(this.search_query);
            },
            viewing_item() {
                return !_.isEmpty(this.current_item);
            },
            active_users() {
                return _.filter(this.items, function (item) {
                    return item.is_active && item.is_setup;
                });
            },
            uninvited_users() {
                return _.filter(this.items, function (item) {
                    return !item.is_setup && item.is_active && !item.is_invited;
                });
            },
            invited_users() {
                return _.filter(this.items, function (item) {
                    return !item.is_setup && item.is_active && item.is_invited;
                });
            },
            inactive_users() {
                return _.filter(this.items, function (item) {
                    return !item.is_active;
                });
            },
        },
        methods: {
            sendInvite(user){
                axios.put(user._links.api.invite)
                    .then(response => {

                    });
            },
            getPeople() {
                var that = this;
                this.people = [];
                axios.get(appUrls.contacts.index)
                    .then(response => {
                        _.forEach(response.data.data, function (person) {
                            var userExists = _.find(that.items, { 'person_id': person.id});
                            if( !userExists ){
                                that.people.push({
                                    label: person.name,
                                    value: person.id
                                });
                            }
                        });
                    });
            },
            refreshCurrentItem() {
                var that = this;
                var url = appUrls.users.show.replace('REPLACEME', this.current_item.id);

                axios.get(url)
                    .then(response => {
                        that.current_item = response.data.data;
                    });
            },
            saveItem: function () {
                var that = this;
                var formDataObject = new FormData();
                var editingItem = $.extend({}, this.current_item);
                var saveUrl = appUrls.users.update.replace('REPLACEME', editingItem.id);

                _.forIn(editingItem, function (value, key) {
                    if( !_.isNull(value) )
                    {
                        formDataObject.append(key, value);
                    }
                });

                formDataObject.append('_method', 'put');

                axios.request({
                    method: 'post',
                    url: saveUrl,
                    data: formDataObject,
                    config: {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        }
                    }
                }).then(response => {
                    that.current_item = response.data.data;
                    that.viewItem(that.current_item);

                }).catch(function (error) {
                    if (error.response.status === 422) {
                        that.errors = error.response.data.errors;
                    }
                });
            },
            resetErrors() {
                this.errors = null;
            },
            addItem() {
                var that = this;
                var data = $.extend({}, this.new_item);
                var formDataObject = new FormData();
                if(_.isObject(this.new_item.person) && !_.isEmpty(this.new_item.person) && this.new_from_contact)
                {
                    formDataObject.append('person_id',this.new_item.person.value);
                }

                var addUrl = appUrls.users.store;

                _.forIn(data, function(value, key) {
                    formDataObject.append(key, value);
                });

                var standardCallback = function (item) {
                    that.items.push(item);
                    that.viewItem(item);

                };

                axios.request({
                    method: 'post',
                    url: addUrl,
                    data: formDataObject,
                    config: {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        }
                    }
                }).then(response => {
                    standardCallback(response.data.data);

                    // Any other custom methods here.
                }).catch(function (error) {
                    if (error.response.status === 422) {
                        that.errors = error.response.data.errors;
                    }
                });
            },

            // The Big Daddy Of Methods - Retrieves all methods.
            getItems() {
                var that = this;
                var url = appUrls.users.index;
                var getVarName = 'user';
                var params = {};

                if (this.has_query) {
                    params.query = this.search_query;
                }

                axios.get(url, {params: params})
                    .then(response => {
                        that.items = response.data.data;
                        that.getPeople();
                        var hasGetVariable = location.search.indexOf(getVarName + '=') >= 0;

                        if (hasGetVariable) {
                            var idFromVariable = getParameterByName(getVarName);
                            if (fieldWithValueExistsInCollection(that.items, 'id', idFromVariable)) {
                                that.viewItem(getItemByFieldAndValue(that.items, 'id', idFromVariable));
                            }
                        }
                    });
            },

            viewItem(item) {
                window.eventBus.$emit('crud-view-item-' + this.name, item);
            },
            backToNav: function () {
                window.eventBus.$emit('crud-back-to-nav-' + this.name);
            },
            backToItem: function () {
                window.eventBus.$emit('crud-back-' + this.name);
            }
        },
        mounted() {
            var that = this;
            this.getItems();

            window.eventBus.$on('crud-search-query-changed-' + this.name, _.debounce(function (query) {
                that.search_query = query;
                that.getItems();
            }, 250));

            window.eventBus.$on('crud-errors-dismissed', function () {
                that.errors = null;
            });

            window.eventBus.$on('crud-edit-item-' + this.name, function (item) {
                this.new_item = {};
                this.current_item = item;
                that.resetErrors();
            });

            window.eventBus.$on('crud-delete-item-' + this.name, function (item) {
                that.deleteItem(item);
                that.resetErrors();
            });

            window.eventBus.$on('crud-view-item-' + this.name, function (item) {
                that.new_item = {};
                that.current_item = item;
                that.resetErrors();
            });

            window.eventBus.$on('crud-back-' + this.name, function (item) {
                that.current_item = item;
                that.viewItem(item);
                that.resetErrors();
            });

            window.eventBus.$on('crud-back-to-nav-' + this.name, function () {
                that.current_item = {};
                that.new_item = {};
                that.resetErrors();
            });
        }
    }
</script>

<style lang="scss">
    /*SASS Goes Here*/
    @import '../../sass/setup';
</style>
